<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { useReadStatusStore, RESUME_URL_FRAGMENT } from "%/dynamic-component-editor/stores/read-status-store";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

const EXAMPLE_PERCENT = 45;
const MSG_RESUME_READING_LABEL = "Resume reading";

export default {
  name: "ResumeReadingCta",
  elementPanelSettings: {
    displayName: "Resume Reading",
    displayIcon: "mdi:play-circle-outline",
    elementGroup: "storyElements",
    elementType: "element",
  },
  extends: BaseButtonElement,
  mixins: [StoryPageElementMixin],
  data() {
    return {
      initialValue: MSG_RESUME_READING_LABEL,
    };
  },
  computed: {
    readPercent() {
      if (this.editMode || this.isPreviewMode) {
        return EXAMPLE_PERCENT;
      }
      return useReadStatusStore().percentByStory[this.storyEntityId]
        ?? this.entity?.readPercent
        ?? 0;
    },
    isOnResumeStoryPage() {
      const readerStoryId = Number(window.blclient?.data?.readerStoryId) || 0;
      return readerStoryId !== 0 && readerStoryId === Number(this.storyEntityId);
    },
  },
  methods: {
    handleButtonClick() {
      if (this.editMode || this.isPreviewMode) {
        return;
      }
      if (this.isOnResumeStoryPage) {
        useReadStatusStore().scrollToReadPercent(this.readPercent);
        return;
      }
      const base = window.blclient?.data?.links?.web ?? "";
      window.location.assign(`${base}/story/${this.storyEntityId}#${RESUME_URL_FRAGMENT}`);
    },
  },
};
</script>
